<template>
	<Layout :loading="loading" :pageTitle="'Ordenes de compra'">
		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en ordenes de compra"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div class="container-fluid">
			<div class="card mt-2">
				<div class="card-body">
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Creada</td>
							<td>Cliente</td>
							<td>Monto total</td>
							<td>Cobro</td>
							<td class="text-right">Estado</td>
						</tr>

						<router-link
							tag="tr"
							:to="`${$route.path}/${item.id}`"
							v-for="(item, index) of list"
							:key="index"
						>
							<td>
								<div class="tc">
									<span>{{ item.createdAt | moment("DD-MM-YYYY HH:mm") }}</span>
									<span class="text-primary">{{ item.code }}</span>
								</div>
							</td>
							<td>
								<div class="tc" v-if="item.client">
									<span>{{ item.client.name }} {{ item.client.lastname }}</span>
									<span class="text-secondary">{{ item.client.email }}</span>
								</div>
							</td>

							<td>
								<div class="tc">
									<div>U$S {{ item.priceTotal }}</div>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="d-flex ">
										<i class="dot mt-1 mr-1" :class="`dot-${item.paymentStatusClass}`"></i>
										<span>{{ item.paymentStatusText }}</span>
									</span>
								</div>
							</td>
							<td>
								<span class="d-flex justify-content-end">
									<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
									<span>{{ item.statusText }}</span>
								</span>
							</td>
						</router-link>
					</table>

					<div class="alert alert-light text-center mt-5" v-if="list.length == 0">
						No se han encontrado ordenes de compra
					</div>

					<Pagination :pageData="pagination" @pageChange="pageChange" @pageLength="pageLength" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Orders",
	data() {
		return {
			list: [],
			loading: false
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							orders(take: $take, skip: $skip, search: $search) {
								data {
									id
									code
									priceTotal
									client {
										id
										name
										lastname
										email
									}
									createdAt
									status
									statusText
									statusClass
									paymentStatusText
									paymentStatusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.orders.data
					this.pagination.pageInfo = data.orders.pageInfo
					this.loading = false
				})
		}
	}
}
</script>
